import React, { useEffect, useContext, useState } from "react";
import styles from "./ApplicationForm.module.css";
import ApplicationCategory from "./components/formCategories/ApplicationCategory";
import ApplicationDetails from "./components/formCategories/ApplicationDetails";
import ApplicationAddress from "./components/formCategories/ApplicationAddress";
import EmergencyContact1 from "./components/formCategories/EmergencyContact1";
import EmergencyContact2 from "./components/formCategories/EmergencyContact2";
import EmployerDetails from "./components/formCategories/EmployerDetails";
import PropertyDetails from "./components/formCategories/PropertyDetails";
import ESignature from "./components/formCategories/ESignature";
import AppButton from "component/button/AppButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { mortgageApplicationSchema } from "schemas/mortgageApplication/MortgageApplicationSchema";
import { UserContext } from "context/UserContext";
import CoApplicantSignature from "./components/formCategories/CoApplicantSig";
import CoApplicantDetails from "./components/formCategories/CoApplicantDetails";
import RsaEquityContribution from "./components/formCategories/RsaEquityContribution";
import StanbicAccount from "./components/formCategories/StanbicAccount";
import FindProperty from "./components/formCategories/FindProperty";
import { parseData } from "utils/helpers";

function ApplicationForm({
  application,
  formState,
  handleCloseModal,
  submit,
  loading,
  saveAndQuit,
  setSaveAndQuit,
}) {
  const { user } = useContext(UserContext);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(mortgageApplicationSchema),
  });

  const formData = watch();

  useEffect(() => {
    if (formState === "continuation") {
      Object.keys(application).map((item) => {
        if (application[item] !== null) {
          if (item === "rsaEquityContribution") {
            setValue(
              "rsaEquityContribution",
              JSON.stringify(application[item])
            );
          } else if (item === "haveBankAccount") {
            setValue("haveBankAccount", JSON.stringify(application[item]));
          } else if (item === "foundProperty") {
            setValue("foundProperty", JSON.stringify(application[item]));
          } else if (item === "dob") {
       
            setValue("dob", application[item]);
          } else if (item === "coDob") {
      
           setValue("coDob", application[item]);
          } else if (item === "residenceSince") {
            setValue("residenceSince", application[item]);
          } else if (item === "employmentDate") {
            setValue("employmentDate", application[item]);
          } else if (item === "signDate") {
            setValue("signDate", new Date());
          } else if (item === "coSignDate") {
            setValue("coSignDate", new Date());
          } else {
            setValue(item, application[item]);
          }
        } else {
          setValue(item, "");
        }
      });
    } else {
      setValue("email", user?.email);
      setValue("firstName", user?.firstName);
      setValue("lastName", user?.lastName);
      setValue("signDate", new Date());
      setValue("coSignDate", new Date());
    
    }
  }, [application]);

  const onSubmit = (data) => {
    setSaveAndQuit(false);
    submit({
      ...data,
      submitted: true,
      netSalary: parseInt(data.netSalary),
      rsaEquityContribution: parseData(data.rsaEquityContribution),
      foundProperty: parseData(data.foundProperty),
      propertyEquityContribution: parseData(data.propertyEquityContribution),
    });
  };

  const handleSaveAndQuit = (data) => {
    setSaveAndQuit(true);
    submit({
      ...data,
      submitted: false,
      netSalary: parseInt(data.netSalary),
      rsaEquityContribution: parseData(data.rsaEquityContribution),
      foundProperty: parseData(data.foundProperty),
      propertyEquityContribution: parseInt(data.propertyEquityContribution),
    });
  };

  return (
    <div className={styles.application_form}>
      <div className={styles.body}>
        <ApplicationCategory errors={errors} register={register} />
        <ApplicationDetails
          trigger={trigger}
          watch={watch}
          formData={formData}
          setValue={setValue}
          errors={errors}
          register={register}
        />
        {formData?.category === "joint" && (
          <CoApplicantDetails
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            formData={formData}
            errors={errors}
            register={register}
          />
        )}
        <ApplicationAddress
          trigger={trigger}
          setValue={setValue}
          formData={application}
          watch={watch}
          errors={errors}
          register={register}
        />
        <EmergencyContact1
          trigger={trigger}
          setValue={setValue}
          formData={formData}
          application={application}
          watch={watch}
          errors={errors}
          register={register}
        />
        <EmergencyContact2
          trigger={trigger}
          setValue={setValue}
          formData={formData}
          application={application}
          watch={watch}
          errors={errors}
          register={register}
        />
        <EmployerDetails
          trigger={trigger}
          setValue={setValue}
          formData={formData}
          application={application}
          watch={watch}
          errors={errors}
          register={register}
        />
        <RsaEquityContribution
          setValue={setValue}
          formData={formData}
          application={application}
          watch={watch}
          errors={errors}
          register={register}
        />
        <StanbicAccount
          setValue={setValue}
          formData={formData}
          watch={watch}
          errors={errors}
          register={register}
        />
        {/* <UploadDocument watch={watch} errors={errors} register={register} /> */}
        <FindProperty
          formData={formData}
          watch={watch}
          errors={errors}
          register={register}
        />
        <PropertyDetails
        trigger={trigger}
          formData={application}
          setValue={setValue}
          watch={watch}
          errors={errors}
          register={register}
        />
        <ESignature
          watch={watch}
          setValue={setValue}
          formData={formData}
          application={application}
          errors={errors}
          register={register}
          trigger={trigger}
        />
        {formData?.category === "joint" && (
          <CoApplicantSignature
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            formData={formData}
            application={application}
            errors={errors}
            register={register}
          />
        )}
        <div className={styles.application_btns}>
          <AppButton
            loading={saveAndQuit ? loading : false}
            handleAction={() => {
              handleSaveAndQuit(formData);
            }}
            textColor="#fff"
            btnBg="#CE0000"
            btnText="Save & Exit"
            width="30%"
          />
          <AppButton
            loading={saveAndQuit ? false : loading}
            handleAction={handleSubmit(onSubmit)}
            textColor="#FFFFFF"
            btnBg="#0089FF"
            btnText="Continue"
            width="30%"
          />
        </div>
      </div>
    </div>
  );
}

export default ApplicationForm;